import React from "react";
import { RemovableLabel, type RemovableProps } from "./Removable";
import { ContactSidePanel } from "components/SidePanel/contact/ContactSidePanel";
import { useContact } from "utilities/api/contactQuery";

type Props = RemovableProps<server.dto.ContactSmallV2>;

export const RemovableContactLabel = (props: Props) => {
  const contact = useContact(props.value);

  return <RemovableLabel {...props}>
    <div>
      <ContactSidePanel
        contactId={props.value.contactId}
        trigger={<a>{contact.name.fullName}</a>}
      />
      {props.value.position && <div className="text-sublabel">
        {props.value.position}
      </div>}
    </div>
  </RemovableLabel>;
};